import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import ColorHash from 'color-hash';
import Masonry from 'react-masonry-component';

import { getMainDomain } from 'helpers/whiteLabel';
import { getThumbFile } from 'helpers/items';
import { getTextColor } from 'components/forms/autocomplete/Color';

import Loader from 'components/layout/Loader';
import RoundImage from 'components/layout/RoundImage';
import List from 'components/List';

import CmsElementHero from 'components/cms/elements/CmsElementHero';

import OrdersList from 'components/layout/dashboard/customer/OrdersList';
import VendorOrdersList from 'components/layout/dashboard/customer/VendorOrdersList';
import PriceNegotiations from 'components/layout/dashboard/customer/PriceNegotiations';
import YourCar from 'components/layout/dashboard/customer/YourCar';
import AddYourCar from 'components/layout/dashboard/customer/AddYourCar';

class DashboardVendor extends React.Component {
  constructor(props) {
    super(props);

    this.colorHash = new ColorHash();
  }

  getBackgroundUrlParam = () => {
    const { projectConfig } = this.props;
    return getMainDomain(projectConfig.data, true, false) + '/img/default_customer_portal_image.jpg';
  };

  getHeaderMessageParam = () => {
    const {
      intl: { formatMessage },
      projectConfig,
    } = this.props;

    return (
      '<div class="p-t-100 p-b-30"><h2>' +
      formatMessage({ id: 'your_project_dashboard' }, { project: projectConfig.data.name }) +
      '</h2></div>'
    );
  };

  render() {
    const { intl, appIntl, user, vendorOrdersList, openOrdersList, priceNegotiationsList, clientCarsList } = this.props;

    let avatarThumbLink = null;
    if (user.profile.avatar) {
      const imageThumb = getThumbFile(user.profile.avatar);
      avatarThumbLink = imageThumb ? imageThumb.web_link : null;
    }

    const avatarColor = this.colorHash.hex(user.profile.first_name + user.profile.last_name);
    const avatarTextColor = getTextColor(avatarColor);

    const pending = vendorOrdersList.pending; // || openOrdersList.pending;

    return (
      <div>
        <List
          listName="newVendorOrders"
          url="/api/vendororders.json"
          urlData={{
            filters: {
              isAccepted: false,
            },
          }}
          list={vendorOrdersList}
          noRender
        />
        {/*<List
          listName="openVendorOrders"
          url="/api/vendororders.json"
          urlData={{
            filters: {
              is_accepted: true,
              is_closed: false,
              is_cancelled: false,
            },
          }}
          list={vendorOrdersList}
          noRender
        />*/}

        <div className="gradient-grey">
          <CmsElementHero
            intl={intl}
            appIntl={appIntl}
            index="0"
            params={[
              { name: 'mainColor', value: 'white' },
              { name: 'isFluid', value: 'yes' },
              { name: 'backgroundUrl', value: this.getBackgroundUrlParam() },
              { name: 'content', value: this.getHeaderMessageParam() },
            ]}
          />
        </div>

        <Grid>
          <Row>
            <Col xs={12} lg={6}>
              <div className="container-xs-height">
                <div className="row-xs-height">
                  <div className="social-user-profile col-xs-height text-center col-top">
                    {avatarThumbLink ? (
                      <RoundImage size={50} usePixels url={avatarThumbLink} />
                    ) : (
                      <div style={{ opacity: '.6' }}>
                        <RoundImage size={50} usePixels hexColor={avatarColor}>
                          <h6 style={{ color: avatarTextColor }} className="bold">
                            {user.profile.first_name.substring(0, 1)}&nbsp;{user.profile.last_name.substring(0, 1)}
                          </h6>
                        </RoundImage>
                      </div>
                    )}
                  </div>
                  <div className="col-xs-height p-l-20">
                    <h3 className="no-margin p-b-5">
                      <FormattedMessage
                        id="welcome_message"
                        values={{
                          name: user.profile.first_name + ' ' + user.profile.last_name,
                        }}
                      />
                    </h3>
                    <p className="no-margin fs-16">
                      {user.profile.street} {user.profile.house_number} | {user.profile.zip_code} {user.profile.city}
                    </p>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} lg={6}>
              <p className="no-margin fs-16">Willkommen in unserem Lieferantenportal.</p>
              <p className="hint-text m-t-5 small">
                Über Ihr Konto können Sie Kontakt mit uns aufnehmen, Bestellungen einsehen, annehmen und bearbeiten, Preisverhandlungen führen
                und Ihre Produkte definieren.
              </p>
            </Col>
          </Row>

          <Row className="p-t-20 p-b-50">
            {pending ? (
              <Col xs={12}>
                <Loader />
              </Col>
            ) : (
              <Masonry
                className="customer-dashboard"
                elementType="div"
                options={{
                  transitionDuration: 200,
                  itemSelector: '.grid-item',
                  // use element for option
                  columnWidth: '.grid-sizer',
                  percentPosition: true,
                }}
                disableImagesLoaded={false}
                updateOnEachImageLoad
              >
                <Col xs={3} className="grid-sizer" />

                {/* display orders list */}
                <VendorOrdersList list={vendorOrdersList} />

                {/* display list of booked service appointments
                <VendorOrdersList list={openOrdersList} />*/}

                {/* display price negotiations
                <PriceNegotiations list={priceNegotiationsList} />

                {clientCarsList.data.list.map(clientCar => {
                  return <YourCar car={clientCar} key={clientCar.id} />;
                })}

                <AddYourCar />*/}
              </Masonry>
            )}
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    vendorOrdersList: state.list.newVendorOrders,
    priceNegotiationsList: state.list.priceNegotiations,
    clientCarsList: state.list.clientCars,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardVendor)));
